import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['taxField'];

  connect() {
    this.update();
  }

  update() {
    const selected = this.element.querySelector('input[name*="company_type"]:checked')?.value;
    this.taxFieldTargets.forEach((field) => {
      field.hidden = field.dataset.companyType !== selected;
    });
  }
}
